import { render, staticRenderFns } from "./DimitraModule.vue?vue&type=template&id=c48c700a&scoped=true"
import script from "./DimitraModule.vue?vue&type=script&lang=js"
export * from "./DimitraModule.vue?vue&type=script&lang=js"
import style0 from "./DimitraModule.vue?vue&type=style&index=0&id=c48c700a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48c700a",
  null
  
)

export default component.exports